@if ((locationItems$ | async); as locations) {
    <div class="items"
         [class.is-editing]="isEditing"
         [class.can-drop]="draggingTeamCanBeDroppedIntoZone"
         [class.cannot-drop]="!draggingTeamCanBeDroppedIntoZone"
         [nxtSortablejs]="undefined"
         [config]="sortableOptions"
         [attr.data-location]="'zone-' + zone"
         [attr.data-zone-name]="ZoneName[zone]"
         data-test="location-entity-list">
        @for (teamLocation of locations; track teamLocation.teamLocationId) {
            <ng-container [ngTemplateOutlet]="teamTemplate ?? defaultTemplate"
                          [ngTemplateOutletContext]="{$implicit: teamLocation.team, teamLocation}"></ng-container>
        }
    </div>
}

<ng-template #defaultTemplate>
    <div class="pb-1"></div>
</ng-template>
